import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Infrastructure from "./sections/Infrastructure";
import Pillars from "./sections/Pillars";
import Framework from "./sections/Framework";
import Standards from "./sections/Standards";
import Foundation from "./sections/Foundation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Infrastructure />
      <Pillars />
      <Framework />
      <Standards />
      <Foundation />
      <Footer />
    </div>;
}